import makeStyles from "@material-ui/core/styles/makeStyles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  root: {
    backgroundColor: "#eeeeee",
    boxShadow: "none",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 48,
    height: 48,
    borderColor: "#d8d8d8",
    borderRight: "1px solid #eeeeee",
    "&:last-child": {
      borderRight: `1px solid ${theme.palette.text.hint}`
    }
  },
  date: {
    lineHeight: "normal",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "bold",
    textAlign: "center",
    borderRadius: 3,
    fontSize: 14,
    height: 26,
    width: 26,
    color: "#d8d8d8"
  },
  squared: {
    borderRadius: 2,
    width: 20,
    height: 20,
    border: "1px solid"
  }
}));
